(function () {
    'use strict';

    angular.module("imApp").factory("stockOutgoingService", ['$ihttp', function ($ihttp) {
        let service = {
            listStockOutgoings: function (parms) {
                return $ihttp.post({
                    method: 471,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
